<template>
<div class="WAdvancedSearch">
  <div class="input-with-select el-input el-input--small el-input-group el-input-group--prepend">
    <div class="el-input__inner" style="height:33px;cursor:pointer" :style="'width:331px;border-top-left-radius: 4px;border-bottom-left-radius: 4px;'">
      <el-popover    
        style="display:block;height:100%"
        trigger="click" 
        placement="bottom"
        width="500">
        <popover-options
          :form="allTableHeaders"
          :showList="showList">          
        </popover-options>        
        <span slot="reference" class="tagWarp" @click="visible = !visible">
          <el-scrollbar>
            <div class="" style="height:31px" v-if="showList.length > 0">
              <el-tag size="mini">{{showList[0].name}}</el-tag>
              <el-tag size="mini" v-if="showList.length > 1">+{{showList.length-1}}</el-tag>                
            </div>              
          </el-scrollbar>
        </span>        
      </el-popover>
      <div v-if="showList.length>0" class="el-input__suffix" @click.stop="handleClear">
        <i class="el-input__icon el-icon-circle-close el-input__clear"></i>
      </div>
      
    </div>      
  </div>
</div>
  
</template>
<script>
import PopoverOptions from './PopoverOptions'
export default {
  name: 'WAdvancedSearch',
  props: {
    allTableHeaders: {
      type: Array,
      required: true
    },
    hasSelect: {
      type: Boolean,
      default: true
    }
  },
  components: {
    PopoverOptions
  },
  data() {
    return {
      // showList: [],
      visible: false,
      sheetId: '',
      fieldArr: []
    }
  },
  created() {
    // this.allTableHeaders.forEach(a => {
    //   this.$set(a, 'filter', a.baseType === 3 ? [] : '')
    // })
  },
  computed: {
    showList() {
      return this.allTableHeaders.filter(f => f.baseType === 3 ? f.filter.length > 0 && f.filter[0] !== '' && f.filter[1] !== '' : f.filter !== '' && f.filter !== null)
    }
  },
  methods: {
    handleClear() {
      this.allTableHeaders.forEach(f => {
        this.$set(f, 'filter', f.baseType === 3 ? [] : '')
      })

      this.$nextTick(() => {
        this.$emit('handleClear')
      })
    }
  }
}
</script>
<style lang="scss">
.WAdvancedSearch{
  height: 33px;
  display: inline-block;
  .el-select{
    margin-left:-20px;
    height: 33px;
    line-height: 33px;
  }
  .el-select .el-input {
    width: 150px;
  }
  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
  div.el-input__inner{
    padding:0 10px;
    .el-input__suffix{
      z-index: 9999;
      pointer-events:visible;
    }
  }
  .tagWarp{
    text-align: left;
    display: block;
    width: 100%;
    height: 100%;
    .el-scrollbar__view{
      height: 31px;
    }
  }
  .scrollbar-wrapper {
    overflow-x: hidden!important;
    .el-scrollbar__view {
      height: 100%;
    }
  }
}  
</style>


